import {
  TIMELINE_CART_STATUS_SUFFIX,
  TIMELINE_STATUS,
  TIMELINE_STATUS_LABEL,
} from "constants/filingsTimeline";
import { TimelineFilingRow } from "store/apis/filingsTimeline";
import { getTimelineStatus } from "./getTimelineStatus";

export const getFilingDetailStatus = (filing: TimelineFilingRow): string => {
  const isUnpaid = getTimelineStatus(filing) === TIMELINE_STATUS.UNPAID;

  if (!isUnpaid) return filing.status_display;

  if (!filing.cart_status) return TIMELINE_STATUS_LABEL.UNPAID;

  const suffix = TIMELINE_CART_STATUS_SUFFIX[filing.cart_status];

  return `${TIMELINE_STATUS_LABEL.UNPAID} (${suffix})`;
};
